export const getBuyingOnlineOfferEngagementEndpoint = (offerId: string) =>
  `${process.env.API_URL}/dms/v1/business-case/buying-online-offer/${offerId}/engagement`;
